import {Injectable} from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
} from '@angular/common/http'
import {Observable} from 'rxjs'

import {AppConfigService} from '@app/app-config.service'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly urlPrefix: string = 'api://'

  constructor(private config: AppConfigService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // this.logger.log('api intercepted', req);
    // IMPORTANT, this interceptor must be last because it strips the api:// scheme
    if (req.url.startsWith(this.urlPrefix)) {
      // this is an api request
      // insert the api-url
      const url: string = req.url.replace(this.urlPrefix, this.config.apiUrl)
      let headers: HttpHeaders = req.headers.set('Accept', 'application/*')

      // set the content type header if it is not set yet
      // exception for the formdata body
      if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
        headers = headers.set('Content-Type', 'application/json')
      }
      req = req.clone({url: url, headers: headers})
    }
    return next.handle(req)
  }
}
